export const relationshipTypes = [
    { label: "belongs to", value: "belongs to" },
    { label: "uses", value: "uses" },
    { label: "contains", value: "contains" },
    { label: "has", value: "has" },
    { label: "extends", value: "extends" },
    { label: "implements", value: "implements" },
    { label: "depends on", value: "depends on" },
    { label: "composed of", value: "composed of" },
];
